// extracted by mini-css-extract-plugin
export default {"navigation":"PageNavigation_navigation__ScBkF","navBtn":"PageNavigation_navBtn__oMxIL","counter":"PageNavigation_counter__zEfsP"};